import { Stack, styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

export const PasswordFieldStack = styled(Stack)(() => ({
  gap: uni('scale-100'),
  width: '100%',
}));
